module.exports = __webpack_public_path__ + "img/aze.5857df00.svg";